import Webapi from './webapi'
import auth from '../auth'

const V1 = 'application/vnd.budbee.roles-v1+json'
const V2 = 'application/vnd.budbee.roles-v2+json'

const webapi = (contentType) =>
    new Webapi()
        .authorization(auth.get())
        .accept(contentType)
        .contentType(contentType)
        .path('roles')

export const getRoles = () => webapi(V2).get()

export const getAllRoles = () => webapi(V1).get()

export const getRole = (id) =>
    webapi(V1)
        .path(id)
        .get()
